<template>
	<SOSlotBase
		:bg-white="true"
		:loading="pageSetting.loading">
		>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="bg-gray p-x-20 p-y-8">
				<div class="f-regular f-14 f-c-midgrey">
					Kode akun {{ rekeningBankDetail.idakun_keuangan }}
				</div>
			</div>

			<SOMenuItemEdit
				:hide-icon="!validateAccess('bank.update')"
				:title="'Nama rekening bank'" 
				:value="rekeningBankDetail.nama"
				class="border-bottom"
				@edit="validateAccess('bank.update') && $router.push({name: 'RekeningBank.UbahNama'})"
			/>
			<SOMenuItemEdit
				:hide-icon="!validateAccess('bank.update')"
				:title="'Nomor rekening'"
				:value="rekeningBankDetail.nomor_rekening"
				:subvalue="'<span class=\'f-bold\'><span class=\'f-c-midgrey\'>a.n</span> '+rekeningBankDetail.pemilik_rekening+'</span>'"
				class="border-bottom"
				@edit="validateAccess('bank.update') &&  $router.push({name: 'RekeningBank.UbahNorek'})"
			/>
			<SOMenuItemEdit
				:hide-icon="!validateAccess('bank.update')"
				:title="'Keterangan'"
				:value="rekeningBankDetail.keterangan === '' ? '-' : rekeningBankDetail.keterangan"
				class="border-bottom"
				@edit="validateAccess('bank.update') &&  $router.push({name: 'RekeningBank.UbahKeterangan'})"
			/>
			<div class="separator"></div>

			<template v-if="validateAccess('bank.read')">
				<SOMenuItemRegular
					:title="'Riwayat Transfer'"
					:subtitle="rekeningBankDetail.last_transfer_formated === '' ? '-' : 'Terakhir ' + rekeningBankDetail.last_transfer_formated"
					:show-subtitle="true"
					:icon-color="'grey'"
					@detail="validateAccess('bank.read') && goRiwayatTransfer(id)"
				/>
				<div class="separator"></div>
			</template>

			<template v-if="validateAccess('bank.transfer')">
				<SOMenuItemIcon
					:title="'Transfer Kas Bank'"
					:icon-plus="true"
					@action="validateAccess('bank.transfer') && $router.push({name: 'RekeningBank.TransferKasBank', params:{id: id}})"
				/>
				<div class="separator"></div>
			</template>

			<template v-if="validateAccess('bank.delete')">
				<SOMenuItemIcon
					:title="'Hapus Rekening'"
					:icon-trash="true"
					:is-trash-red="true"
					@action="validateAccess('bank.delete') && $router.push({name: 'RekeningBank.Delete'})"
				/>
				<div class="separator"></div>
			</template>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOMenuItemEdit from "@/so-components/global/ui/SOMenuItemEdit";
import SOMenuItemRegular from "@/so-components/global/ui/SOMenuItemRegular";
import SOMenuItemIcon from "@/so-components/global/ui/SOMenuItemIcon";

export default {
	name: "RekeningBankDetail",
	components: {
		SOMenuItemIcon,
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
		SOMenuItemEdit,
		SOMenuItemRegular,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBankDetail: "getRekeningBankDetail",
		}),
	},
	data() {
		return {
			id: "",
			pageSetting: {
				pageTitle: "Detail Rekening",
				loading: true
			}
		}
	},
	mounted() {
		this.id = this.$route.params.id
		this.getDetail()
		this.smartTrackingView("detail_rekening_bank");

	},
	methods: {
		back() {
			this.$router.back()
		},
		async getDetail() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankDetail", this.id)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
			}
		},
		async goRiwayatTransfer(id) {
			await this.$store.commit("rekeningBankModule/resetRiwayatTransfer")
			await this.$store.commit("rekeningBankModule/resetPaginationRiwayatTransfer")
			await this.$store.commit("filterGlobalModule/resetFilter")
			await this.$store.commit("rekeningBankModule/resetSearchRiwayatTransfer")
			await this.$store.commit("rekeningBankModule/setIsSearchRiwayatTransfer", false)

			await this.$router.push({name: 'RekeningBank.RiwayatTransfer', params:{id: id}})
		}
	}
}
</script>